import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';
import { ListItemGraphic} from 'rmwc/List';
import {stateToHTML} from 'draft-js-export-html';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import {Editor as DiffEditor} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class UserUploadedResComponent extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
    		modifyForm: false,
    		moreDetails: false,
            migration: false,
    		associationChanged: false,
            uploadDisableButton: true,
            modifyDisable: false,
            migrateDisable: false,
            adminComments: false,
    		data: {
    			resourceId: '',
	    		resourceName: '',
	    		resourceAuthor: '',
	    		resourceDesc: '',
	    		resourceLink: '',
                resourceStatus: ''
	    	},
	    	editData: {
	    		resourceId: '',
	    		resourceName: '',
	    		resourceAuthor: '',
	    		resourceDesc: '',
	    		resourceLink: '',
	    		aspectsComboDropDown: [],
	    		standardComboDropDown: [],
                languageId: '',
                languageDropDown: [],
                complexityId: '',
                complexityDropDown: [],
                resourceClass: '',
                centaRatingDropDown: [],
                centaRating: '',
                levelId: '',
                levelDropDown: [],
                trackDropDown: [],
                buzzwordDropDown: [],
                resourceDropDown: [],
                gradesDropDown: []
	    	},
            commentData: {
                comments: ''
            },
            editorData: {
                htmlText: '',
                editorState: EditorState.createEmpty(),
                contentValue:'',
                contentState:'',
                editorStateRead:EditorState.createEmpty(),
            },
            commentsDisplay: false,
            existingComments: [],
	    	parentStandard: [],
	    	parentAspect: [],
            parentBuzzword: [],
            parentGrade: [],
            addedTracks: [],
            addedResource: [],
            addedBuzzwords: [],
            errorMsg: '',
            fileError: ''
    	}
    }

    componentDidMount() {
    	let data = Object.assign({}, this.state.data)
        let editorData = Object.assign({}, this.state.editorData)

    	data.resourceId = this.props.resourceId
    	data.resourceName = this.props.resourceName
    	data.resourceAuthor = this.props.resourceAuthor
    	//data.resourceDesc = this.props.resourceDescription
        let contentValue = convertFromHTML(this.props.resourceDescription)
        const contentState = ContentState.createFromBlockArray(contentValue);
        editorData.editorStateRead = EditorState.createWithContent(contentState);
    	data.resourceLink = this.props.resourceLink
        data.resourceStatus = this.props.resourceStatus

    	this.setState({data: data, editData: data, editorData: editorData})
    }

    handleResourceNameUpdate = (e) => {
        e.preventDefault()
        let editData = Object.assign({}, this.state.editData)
        editData.resourceName = e.target.value
        this.setState({editData: editData}) 
    }

    handleResourceLinkUpdate = (e) => {
        e.preventDefault()
        let editData = Object.assign({}, this.state.editData)
        editData.resourceLink = e.target.value
        this.setState({editData: editData}) 
    }

    handleResourceAuthorUpdate = (e) => {
        e.preventDefault()
        let editData = Object.assign({}, this.state.editData)
        editData.resourceAuthor = e.target.value
        this.setState({editData: editData})
    }

    handleResourceDescUpdate = (e) => {
        e.preventDefault()
        let editData = Object.assign({}, this.state.editData)
        editData.resourceDesc = e.target.value
        this.setState({editData: editData})
    }

    handleEditorDescriptionUpdate: Function = (editorState) => {
        let editorData = Object.assign({}, this.state.editorData)
        editorData.editorStateRead = editorState
        this.setState({editorData: editorData});
    };



    handleDetails = (e) => {
    	if(this.state.moreDetails === false){
    		this.setState({moreDetails: true, commentsDisplay: false})
    	}
    	else {
    		this.setState({moreDetails: false, commentsDisplay: false})
    	}
    }

    handleModify = (e) => {
    	let editData = Object.assign({}, this.state.editData)
    	let fetchParents = `user/upload_resource/modify/get_parents/${this.state.data.resourceId}`
        let fetchAspects = 'user/affiliate_partner/aspect_details'
        let fetchAffiliateParents = `affiliate_partner/modify/get_parents/${this.state.data.resourceId}`
    	let rawAspects = []
        let getBuzzwords = 'buzzword'
        let getGrades = 'grade'

        if (this.props.user.role === 'user') {
        	api.getUserAspects(this.props.user.accessToken)
            .then((result) => {
                if (result.status === 'success') {
                    editData.aspectsComboDropDown = result.data
                    api.getUserResponse(this.props.user.accessToken, fetchParents)
                    .then((result) => {
                    	if(result.status === 'success'){
                    		let parentStandard = result.data.standards
                    		let parentAspect = result.data.aspects
                    		let value = {
                    			'selected_aspect' : result.data.raw_aspects 
                    		}

                    		api.userAspectAssociatedStandards(this.props.user.accessToken, value)
    				        .then((result) => {
    				            if (result.status === 'success') {
    				                editData.standardComboDropDown = result.data
                    				this.setState({editData: editData, modifyForm: true, parentStandard: parentStandard, parentAspect: parentAspect})
                    			}
                    		})
                    	}
                    })
                    
                }
            })
        }
        else if (this.props.user.role === 'affiliate_partner') {
            api.getUserResponse(this.props.user.accessToken, fetchAspects)
            .then((result) => {
                if (result.status === 'success') {
                    editData.aspectsComboDropDown = result.data
                    api.getUserResponse(this.props.user.accessToken, fetchAffiliateParents)
                    .then((result) => {
                        if(result.status === 'success'){
                            let parentStandard = result.data.standards
                            let parentAspect = result.data.aspects
                            let parentGrade = result.data.grades
                            let parentBuzzword = result.data.buzzwords
                            let value = {
                                'selected_aspect' : result.data.raw_aspects 
                            }

                            api.userAspectAffiliatedStandards(this.props.user.accessToken, value)
                            .then((result) => {
                                if (result.status === 'success') {
                                    editData.standardComboDropDown = result.data
                                    api.getResponse(this.props.user.accessToken, getBuzzwords)
                                    .then((result) => {
                                        if (result.status === 'success') {
                                            editData.buzzwordDropDown = result.data
                                            api.getResponse(this.props.user.accessToken, getGrades)
                                            .then((result) => {
                                                if (result.status === 'success') {
                                                    editData.gradesDropDown = result.data
                                                    this.setState({editData: editData, modifyForm: true, parentStandard: parentStandard, parentAspect: parentAspect, parentGrade: parentGrade, parentBuzzword: parentBuzzword})
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
        }
    }

    CancelModify = (e) => {
    	this.setState({modifyForm: false, modifyDisable: false})
    }

    handleTaxonomyParentUpdate = (option) => {
        this.handleFetchAssociatedStandards(option)
        this.setState(state => {
            return {
                parentStandard : [],
                associationChanged: true,
                parentAspect : option
            };
        });
    }

    handleFetchAssociatedStandards = (option) => {
        let selectedAspect = []
        let editData = Object.assign({}, this.state.editData)

        var myAspectArray = option;
        var aspectLength = myAspectArray.length;
        for (var i = 0; i < aspectLength; i++) {
            selectedAspect.push(parseInt(myAspectArray[i].value))
        }

        let value = {
            'selected_aspect' : selectedAspect
        }
        if (this.props.isAdmin === false) {
            if (this.props.user.role === 'user') {
                api.userAspectAssociatedStandards(this.props.user.accessToken, value)
                .then((result) => {
                    if (result.status === 'success') {
                        editData.standardComboDropDown = result.data
                        this.setState({editData:editData})
                    }
                })
            }
            else {
                api.userAspectAffiliatedStandards(this.props.user.accessToken, value)
                .then((result) => {
                    if (result.status === 'success') {
                        editData.standardComboDropDown = result.data
                        this.setState({editData:editData})
                    }
                })
            }
        }
        else {
            api.getAssociatedStandards(this.props.user.accessToken, value)
            .then((result) => {
                if (result.status === 'success') {
                    editData.standardComboDropDown = result.data
                    this.setState({editData: editData})
                }
            })
        }
    }

    handleStandardUpdate = (option) => {
        this.setState(state => {
            return {
                parentStandard : option
            };
        });
    }

    handleBuzzwordUpdate = (option) => {
        this.setState(state => {
            return {
                parentBuzzword : option
            };
        });
    }

    handleGradeUpdate = (option) => {
        this.setState(state => {
            return {
                parentGrade : option
            };
        });
    }

    handleAdminActivity = (e, status) => {
        e.preventDefault()
        let value
        if (status !== 'Rejected') {
            value = {
                'id': this.state.data.resourceId,
                'status': status
            }
        }
        else {
            if (this.state.commentData.comments.length > 2000) {
                return this.setState({errorMsg: `Your comment has ${this.state.commentData.comments.length} characters. Please ensure that the comments are not more than 2000 characters.`})
            }
            value = {
                'id': this.state.data.resourceId,
                'status': status,
                'comments': this.state.commentData.comments
            }
        }

        api.userResourceAdminActivity(this.props.user.accessToken, value)
        .then((result) => {
            if (result.status === 'success'){
                this.props.onHandleUpdateActivity()
            }
        })
    }

    handleResourceUpdate = (e) => {
        e.preventDefault()
        let htmlText
        this.setState({modifyDisable: true})

        htmlText = stateToHTML(this.state.editorData.editorStateRead.getCurrentContent())

        if (this.props.user.role === 'affiliate_partner'){
            if (htmlText.length > 5000){
                return this.setState({errorMsg: 'The description is too long. Please make the necessary changes.', modifyDisable: false})
            }
        }
        else if (this.props.user.role === 'user'){
            if (htmlText.length > 3000){
                return this.setState({errorMsg: 'The description is too long. Please make the necessary changes.', modifyDisable: false})
            }
        }

        if (this.props.user.role === 'user'){
            if (this.state.editData.resourceDesc > 2000){
                return this.setState({errorMsg: 'The description is too long. Please make the necessary changes.', modifyDisable: false})
            }
        }

        if (this.props.resourceType === 'link') {
            if (this.state.editData.resourceLink === '') {
                return this.setState({errorMsg: 'Please enter the link of the resource before adding a resource. All fields are mandatory.', modifyDisable: false})
            }
        }

        if (this.props.user.role === 'affiliate_partner') {
            if (this.state.parentGrade.length === 0) {
                return this.setState({errorMsg: 'Please enter the necessary details before updating the resource. All fields are mandatory.', modifyDisable: false})
            }
        }

        if ((this.state.editData.resourceName === '') || (this.state.parentStandard.length === 0)){
            return this.setState({errorMsg: 'Please enter the necessary details before updating the resource. All fields are mandatory.', modifyDisable: false})

        }

        let data = Object.assign({}, this.state.data)
        const formData = new FormData(e.target);

        var taxonomyArray = this.state.parentAspect;
        var taxonomyLength = taxonomyArray.length;
        let selectedTaxonomyString = []
        for (var z = 0; z < taxonomyLength; z++) {
            selectedTaxonomyString.push(parseInt(taxonomyArray[z].value))
        }

        var standardArray = this.state.parentStandard;
        var standardLength = standardArray.length;
        let selectedStandardString = []
        for (var z = 0; z < standardLength; z++) {
            selectedStandardString.push(parseInt(standardArray[z].value))
        }

        formData.append("standards", selectedStandardString)
        formData.append("aspects", selectedTaxonomyString)
        formData.append("description", htmlText)
        
        if (this.props.user.role === 'affiliate_partner') {
            var buzzwordArray = this.state.parentBuzzword;
            var buzzwordLength = buzzwordArray.length;
            let selectedBuzzwordString = []
            for (var z = 0; z < buzzwordLength; z++) {
                selectedBuzzwordString.push(parseInt(buzzwordArray[z].value))
            }

            var gradeArray = this.state.parentGrade;
            var gradeLength = gradeArray.length;
            let selectedGradeString = []
            for (var z = 0; z < gradeLength; z++) {
                selectedGradeString.push(parseInt(gradeArray[z].value))
            }

            formData.append("buzzwords", selectedBuzzwordString)
            formData.append("grades", selectedGradeString)
        }

        if (this.props.user.role === 'user') {
            api.updateUserUploadedResource(this.props.user.accessToken, this.state.data.resourceId, formData)
            .then((result) => {
                if (result.status === 'success') {
                	this.props.onHandleResourceUpdate(e)
                	this.setState({modifyForm: false, modifyDisable: false})
                }
                else {
                    this.setState({modifyDisable: false})
                }
            })
        }
        else if (this.props.user.role === 'affiliate_partner') {
            api.updateUserUploadedModule(this.props.user.accessToken, this.state.data.resourceId, formData)
            .then((result) => {
                if (result.status === 'success') {
                    this.props.onHandleResourceUpdate(e)
                    this.setState({modifyForm: false, modifyDisable: false})
                }
                else {
                    this.setState({modifyDisable: false})
                }
            })
        }
    }

    handleMigration = (e) => {
        let data = Object.assign({}, this.state.editData)
        let fetchLangauges = 'admin/learning_taxonomy/languages'
        let complexity = 'admin/learning_resource/complexity'
        let getBuzzwords = 'buzzword'
        let backwardResource = 'admin/learning_resource/render_resources/association_details'
        let newSectionType = 3
        let taxonomyDropdown = `admin/taxonomy_details/${newSectionType}`
        let fetchUserParents = `admin/user_uploaded_resource/fetch_parent/${this.state.data.resourceId}`

        api.getResponse(this.props.user.accessToken, fetchLangauges)
        .then((result) => {
            data.languageDropDown = result
            api.getResponse(this.props.user.accessToken, complexity)
            .then((result) => {
                data.complexityDropDown = result
                api.adminResourceLevelsBox(this.props.user.accessToken)
                .then((result) => {
                    data.levelDropDown = result.data
                    api.adminResourceTracksBox(this.props.user.accessToken)
                    .then((result) => {
                        data.trackDropDown = result.data
                        api.getResponse(this.props.user.accessToken, getBuzzwords)
                        .then((result) => {
                            if (result.status === 'success'){
                                data.buzzwordDropDown = result.data
                                api.getResponse(this.props.user.accessToken, backwardResource)
                                .then((result) => {
                                    if (result.status === 'success'){
                                        data.resourceDropDown = result.data
                                        api.getResponse(this.props.user.accessToken, taxonomyDropdown)
                                        .then((result) => {
                                            if (result.status === 'success') {
                                                data.aspectsComboDropDown = result.data
                                                api.getResponse(this.props.user.accessToken, fetchUserParents)
                                                .then((result) => {
                                                    if (result.status === 'success'){
                                                        let parentAspect = result.data.aspects
                                                        let parentStandard = result.data.standards

                                                        let value = {
                                                            'selected_aspect' : result.data.raw_aspects
                                                        }

                                                        api.getAssociatedStandards(this.props.user.accessToken, value)
                                                        .then((result) => {
                                                            if (result.status === 'success') {
                                                                data.standardComboDropDown = result.data
                                                                this.setState({editData: data, migration: true, parentAspect: parentAspect, parentStandard: parentStandard})
                                                            }
                                                        })
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    })
                })
            })
        })
    }

    handleLanguageChange = (event) => {
        let data = Object.assign({}, this.state.editData)
        data.languageId = event.target.value
        this.setState({editData: data})
    }

    handleComplexityChange = (event) => {
        let data = Object.assign({}, this.state.editData)
        data.complexityId = event.target.value
        this.setState({editData: data})
    }

    handleResourceClassChange = (event) => {
        let data = Object.assign({}, this.state.editData)
        data.resourceClass = event.target.value
        this.setState({editData: data})
    }

    handleCentaRatingsChange = (event) => {
        let data = Object.assign({}, this.state.editData)
        data.centaRating = event.target.value
        this.setState({editData: data})
    }

    handleResAssociatedTracks = (option) => {
        this.setState(state => {
            return {
                addedTracks : option
            };
        });
    }

    handleBuzzwordsChange = (option) => {
        this.setState(state => {
            return {
                addedBuzzwords : option
            };
        });
    }

    handleBackwardLink = (option) => {
        this.setState(state => {
            return {
                addedResource : option
            };
        });
        //<GridCell span = "6">
        //    <Reactsel
        //        name="buzzwordlist"
        //        onChange={this.handleBuzzwordUpdate}
        //        defaultValue={this.state.parentBuzzword}
        //        options={this.state.editData.buzzwordDropDown}
        //        placeholder="--Select Keyword(s)--"
        //        isMulti>
        //    </Reactsel>
        //</GridCell>
    }

    cancelMigrate = (e) => {
        let editData = Object.assign({}, this.state.editData)
        editData.complexityId = ''
        editData.level = ''
        editData.centaRating = ''
        editData.languageId = ''
        editData.resourceClass = ''
        this.setState({editData: editData, migration: false, addedTracks: [], addedResource: [], addedBuzzwords: [], parentStandard: [], parentAspect: [], errorMsg: '', migrateDisable: false})
    }

    handleAdminResourceSave = (e) => {
        e.preventDefault()

        this.setState({migrateDisable: true})
        let htmlText = stateToHTML(this.state.editorData.editorStateRead.getCurrentContent())

        if (htmlText.length > 5000){
            return this.setState({errorMsg: 'The description is too long. Please make the necessary changes.', migrateDisable: false})
        }

        if (this.state.editData.resourceLink.length > 750) {
            return this.setState({errorMsg: 'The link of the resource is very large. Please contact the Admin.', migrateDisable: false})
        }

        if ((this.state.editData.resourceName === '') || (this.state.editData.languageId === undefined) || (this.state.editData.complexityId === undefined) || (this.state.editData.centaRating === undefined) || (this.state.editData.resourceClass === undefined) || (this.state.parentStandard.length === 0)){
            return this.setState({errorMsg: 'Please enter the necessary details before updating the resource.', migrateDisable: false})
        }

        let data = Object.assign({}, this.state.data)
        const formData = new FormData(e.target);

        var aspectArray = this.state.parentAspect;
        var aspectLength = aspectArray.length;
        let selectedTaxonomyString = []
        for (var i = 0; i < aspectLength; i++) {
            selectedTaxonomyString.push(parseInt(aspectArray[i].value))
        }

        var myStandardArray = this.state.parentStandard;
        var standardLength = myStandardArray.length;
        for (var i = 0; i < standardLength; i++) {
            selectedTaxonomyString.push(parseInt(myStandardArray[i].value))
        }

        var trackArray = this.state.addedTracks;
        var trackLength = trackArray.length;
        let selectedTrackString = []
        for (var z = 0; z < trackLength; z++) {
            selectedTrackString.push(parseInt(trackArray[z].value))
        }

        var buzzwordArray = this.state.addedBuzzwords;
        var buzzwordLength = buzzwordArray.length;
        let selectedBuzzwordString = []
        for (var y = 0; y < buzzwordLength; y++) {
            selectedBuzzwordString.push(parseInt(buzzwordArray[y].value))
        }

        var resourceArray = this.state.addedResource;
        var resourceLength = resourceArray.length;
        let selectedResourceString = []
        for (var x = 0; x < resourceLength; x++) {
            selectedResourceString.push(parseInt(resourceArray[x].value))
        }

        formData.append("resourcedesc", htmlText)
        formData.append("selected_taxonomies", selectedTaxonomyString)
        formData.append("test_track_id", selectedTrackString)
        formData.append("buzzwords", selectedBuzzwordString)
        formData.append("selected_resources", selectedResourceString)
        api.adminAddLearningResource(this.props.user.accessToken, formData)
        .then((result) => {
            if (result.status === 'success') {
                this.props.onHandleUpdateActivity()
                this.setState({snackbarIsOpen: !this.state.snackbarIsOpen, migrateDisable: false})
            }
            else {
                this.setState({migrateDisable: false})
            }
        })
    }

    validateUpload = (event) =>{
        if (event.target.files[0] === undefined){
            return this.setState({uploadDisableButton: true})
        }
        let file_name = event.target.files[0].name;
        let fileSize = event.target.files[0].size/1024/1024;
        let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();

         if ((extension === "pdf") || (extension === "doc") || (extension === "docx")){
            if (fileSize > 10) {
                return this.setState({uploadDisableButton: true, fileError: 'File size exceeds the permisible limit. Please make sure that the file is less than 10 MB.'})
            }
            this.setState({uploadDisableButton: false, fileError: ''})
        }
        else{
            this.setState({uploadDisableButton: true, fileError: 'Invalid File Format. Upload PDF, DOC or DOCX file only.'})
        }
    }

    handleAdminComments = (e) => {
        if (this.state.adminComments === false) {
            this.setState({adminComments: true, errorMsg: ''})
        }
        else {
            this.setState({adminComments: false, errorMsg: ''}) 
        }
    }

    handleCommentsChange = (e) => {
        let commentData = Object.assign({}, this.state.commentData)
        commentData.comments = e.target.value
        this.setState({commentData: commentData})  
    }

    handleFetchComments = (e) => {
        let existingComments = []
        let fetchComments
        if (this.props.isAdmin === true){
            fetchComments = `admin/user_resource/comments/${this.state.data.resourceId}`
        }
        else {
            fetchComments = `affiliate_partner/modules/admin_comments/${this.state.data.resourceId}`
        }

        api.getResponse(this.props.user.accessToken, fetchComments)
        .then((result) => {
            if (result.status === 'success'){
                existingComments = result.data
                this.setState({existingComments: existingComments})
            }
        })
    }

    handleShowComments = (e) => {
        if (this.state.commentsDisplay === false) {
            this.handleFetchComments()
            this.setState({commentsDisplay: true})
        }
        else {
            this.setState({commentsDisplay: false})
        }
    }

    render() {
    	let displayComponent, detailsButton, detailsComponent, docLinkField, hiddenComponent, statusComponent, displayDescription
        let userNameComponent, actionComponent1, actionComponent2, actionComponent3, uploadButtonComponent, saveComponent
        let actionComponent4, actionComponent5, actionComponent6, blankComponent, commentsComponent, displayComments, cancelCommentsDisplay
        let adminStatusComponent, gradeComponent, buzzwordComponent, onHoldComponent
        let handleFetchComments = this.handleFetchComments
        let handleShowComments = this.handleShowComments
    	let handleResourceUpdate = this.handleResourceUpdate
        let handleAdminComments = this.handleAdminComments
    	let handleDetails = this.handleDetails
    	let handleModify = this.handleModify
    	let CancelModify = this.CancelModify
        let handleAdminActivity = this.handleAdminActivity
        let handleMigration = this.handleMigration
        let cancelMigrate = this.cancelMigrate
        const { editorState } = this.state.editorData

        /*-----------------------------------------------------------------------------------------------------*/
        /*-------------- Affilate Partner Component for Displaying the Buzzwords and Grades Begins--------------*/
        /*-----------------------------------------------------------------------------------------------------*/

        if (this.props.isPartner === true) {
            gradeComponent = (
                <GridCell span = "12">
                    <Typography align = "left"><b>Mapped to the following Grade(s):</b> <i>{this.props.grades}</i></Typography>
                </GridCell>
            )

            buzzwordComponent = (
                <GridCell span = "12">
                    <Typography align = "left"><b>Mapped to the following Keyword(s):</b> <i>{this.props.buzzwords}</i></Typography>
                </GridCell>
            )
        }

        if (this.props.userType === 'Affiliate Partner') {
            gradeComponent = (
                <GridCell span = "8">
                    <Typography align = "left"><b>Mapped to the following Grade(s):</b> <i>{this.props.grades}</i></Typography>
                </GridCell>
            )

            buzzwordComponent = (
                <GridCell span = "12">
                    <Typography align = "left"><b>Mapped to the following Keyword(s):</b> <i>{this.props.buzzwords}</i></Typography>
                </GridCell>
            )
        }

        /*-----------------------------------------------------------------------------------------------------*/
        /*-------------- Affilate Partner Component for Displaying the Buzzwords and Grades Ends --------------*/
        /*-----------------------------------------------------------------------------------------------------*/

        /*-----------------------------------------------------------------------------------------------------*/
        /*-------------- Status of Resource/Module display for Admin/User/Affilate Partner Begins--------------*/
        /*-----------------------------------------------------------------------------------------------------*/

        if (this.props.userType === 'User') {
            if (this.state.data.resourceStatus === 'Rejected') {
                statusComponent = (
                    <GridCell span="4">
                        <Typography align = "left"><b>Status :</b> <i>Turned Down</i></Typography>
                    </GridCell>
                )
            }
            else {
                statusComponent = (
                    <GridCell span="4">
                        <Typography align = "left"><b>Status :</b> <i>{this.state.data.resourceStatus}</i></Typography>
                    </GridCell>
                )
            }
        }
        else if (this.props.userType === 'Affiliate Partner') {
            if (this.state.data.resourceStatus === 'Approved') {
                statusComponent = (
                    <GridCell span="4">
                        <Typography align = "left"><b>Status :</b> <i>Mapping Accepted</i></Typography>
                    </GridCell>
                )
            }
            else if (this.state.data.resourceStatus === 'Rejected') {
                statusComponent = (
                    <GridCell span="4">
                        <Typography align = "left"><b>Status :</b> <i>Mapping Misaligned</i></Typography>
                    </GridCell>
                )
            }
            else if (this.state.data.resourceStatus === 'On Hold') {
                statusComponent = (
                    <GridCell span="4">
                        <Typography align = "left"><b>Status :</b> <i>Mapping to be discussed</i></Typography>
                    </GridCell>
                )
            }
            else {
                statusComponent = (
                    <GridCell span="4">
                        <Typography align = "left"><b>Status :</b> <i>{this.state.data.resourceStatus}</i></Typography>
                    </GridCell>
                )
            }
        }

        if (this.props.isPartner === false) {
            adminStatusComponent = (
                <GridCell span="4">
                    <Typography align = "left"><b>Status :</b> <i>{this.state.data.resourceStatus}</i></Typography>
                </GridCell>
            )
        }
        else {
            if (this.state.data.resourceStatus === 'Approved') {
                adminStatusComponent = (
                    <GridCell span="4">
                        <Typography align = "left"><b>Status :</b> <i>Mapping Accepted</i></Typography>
                    </GridCell>
                )
            }
            else if (this.state.data.resourceStatus === 'Rejected') {
                adminStatusComponent = (
                    <GridCell span="4">
                        <Typography align = "left"><b>Status :</b> <i>Mapping Misaligned</i></Typography>
                    </GridCell>
                )
            }
            else if (this.state.data.resourceStatus === 'On Hold') {
                adminStatusComponent = (
                    <GridCell span="4">
                        <Typography align = "left"><b>Status :</b> <i>Mapping to be discussed</i></Typography>
                    </GridCell>
                )
            }
            else {
                adminStatusComponent = (
                    <GridCell span="4">
                        <Typography align = "left"><b>Status :</b> <i>{this.state.data.resourceStatus}</i></Typography>
                    </GridCell>
                )
            }
        }

        /*-----------------------------------------------------------------------------------------------------*/
        /*-------------- Status of Resource/Module display for Admin/User/Affilate Partner Ends  --------------*/
        /*-----------------------------------------------------------------------------------------------------*/

        /*-----------------------------------------------------------------------------------------------------*/
        /*-------------- Comments Display for Admin and Affiliate Partner Begins--------------*/
        /*-----------------------------------------------------------------------------------------------------*/

        if (this.state.commentsDisplay === true) {
            if (this.state.existingComments.length === 0) {
                displayComments = (
                    <GridCell span = "12">
                        <Typography use="headline7" align = "left">There are currently no comments for this module.</Typography>
                    </GridCell>
                )
            }
            else {
                displayComments = (
                    <GridCell span = "12">
                        <Typography use="headline7" align = "left"> The <b>Comments</b> for this module are: </Typography>
                        <ul>
                            {this.state.existingComments.map(function(comments){
                                return (
                                    <Typography use="captions" align = "left"><li>{comments}</li></Typography>
                                )
                            })}
                        </ul>
                    </GridCell>
                )
            }
        }

        /*-----------------------------------------------------------------------------------------------------*/
        /*-------------- Comments Display for Admin and Affiliate Partner Ends--------------*/
        /*-----------------------------------------------------------------------------------------------------*/

        /*-----------------------------------------------------------------------------------------------------*/
        /*-------------- Comments Button Display for the Admin and Affiliate Partner Begins--------------*/
        /*-----------------------------------------------------------------------------------------------------*/

        if (this.props.isAdmin === true) {
            if (this.props.isPartner === true) {
                if (this.state.data.resourceStatus === 'Pending') {
                    if(this.state.adminComments === false) {
                        blankComponent = (
                            <GridCell span = "4">
                            </GridCell>
                        )
                    }
                    else {
                        blankComponent = (
                            <GridCell span = "6">
                            </GridCell>
                        )
                    }
                    commentsComponent = (
                        <GridCell span = "2">
                            <Button dense style={{ width: '100%'}} onClick = {((e) => handleShowComments(e))}>Comments</Button>
                        </GridCell>
                    )
                }
                else {
                    if(this.state.adminComments === false) {
                        if (this.state.data.resourceStatus === 'Approved') {
                            blankComponent = (
                                <GridCell span = "4">
                                </GridCell>
                            )
                        }
                        else if (this.state.data.resourceStatus === 'Migrated') {
                            blankComponent = (
                                <GridCell span = "2">
                                </GridCell>
                            )
                        }
                        else {
                            blankComponent = (
                                <GridCell span = "6">
                                </GridCell>
                            )
                        }
                        commentsComponent = (
                            <GridCell span = "2">
                                <Button dense style={{ width: '100%'}} onClick = {((e) => handleShowComments(e))}>Comments</Button>
                            </GridCell>
                        )
                    }
                    else {
                        blankComponent = (
                            <GridCell span = "6">
                            </GridCell>
                        )
                        commentsComponent = (
                            <GridCell span = "2">
                                <Button dense style={{ width: '100%'}} onClick = {((e) => handleShowComments(e))}>Comments</Button>
                            </GridCell>
                        )
                    }
                }
            }
        }
        else {
            if (this.props.user.role === 'affiliate_partner') {
                
                commentsComponent = (
                    <GridCell span = "2">
                        <Button dense style={{ width: '100%'}} onClick = {((e) => handleShowComments(e))}>Comments</Button>
                    </GridCell>
                )
            }
        }

        /*-----------------------------------------------------------------------------------------------------*/
        /*-------------- Comments Button Display for the Admin and Affiliate Partner Ends--------------*/
        /*-----------------------------------------------------------------------------------------------------*/

        /*-----------------------------------------------------------------------------------------------------*/
        /*-------------- Text Area for the Admin to enter the comments for the Module Begins--------------*/
        /*-----------------------------------------------------------------------------------------------------*/

        if (this.state.adminComments === true){
            let rejectedStatus = 'Rejected'
            actionComponent4 = (
                <GridCell span="12">
                    <TextField textarea fullwidth label="Please enter your Comments" rows="2" name="admin_comments" defaultValue = {this.state.commentData.comments} onChange={this.handleCommentsChange} />
                </GridCell>
            )

            actionComponent5 = (
                <GridCell span = "2">
                    <Button dense style={{ width: '100%'}} onClick = {((e) => handleAdminActivity(e, rejectedStatus))}>Submit</Button>
                </GridCell>
            )

            actionComponent6 = (
                <GridCell span = "2">
                    <Button dense style={{ width: '100%'}} onClick = {((e) => handleAdminComments(e))}>Cancel</Button>
                </GridCell>
            )
        }

        /*-----------------------------------------------------------------------------------------------------*/
        /*-------------- Text Area for the Admin to enter the comments for the Module Ends--------------*/
        /*-----------------------------------------------------------------------------------------------------*/

        if (this.state.migrateDisable === false) {
            saveComponent = (
                <GridCell span = "3">
                    <Button raised style={{ width: '100%'}}>Save</Button>
                </GridCell>
            )
        }
        else {
            saveComponent = (
                <GridCell span = "3">
                    <Button raised disabled style={{ width: '100%'}}>In Process</Button>
                </GridCell>
            )
        }


        if (this.state.modifyDisable === false) {
            if ((this.state.uploadDisableButton === true) && (this.props.resourceType === 'document')){
                uploadButtonComponent = (
                    <GridCell span = "3">
                        <Button raised disabled style={{ width: '100%'}}>Save</Button>
                    </GridCell>
                )
            }
            else{
                uploadButtonComponent = (
                    <GridCell span = "3">
                        <Button raised style={{ width: '100%'}}>Save</Button>
                    </GridCell>
                )
            }
        }
        else {
            uploadButtonComponent = (
                <GridCell span = "3">
                    <Button raised disabled style={{ width: '100%'}}>In Process</Button>
                </GridCell>
            )
        }

        if (this.props.isAdmin === true){
            let acceptedStatus = 'Approved'
            let rejectedStatus = 'Rejected'
            let onHoldStatus = 'On Hold'
            userNameComponent = (
                <GridCell span = "3">
                    <Typography align = "left"><b>User-Name :</b> <i>{this.props.submittedUserName}</i></Typography>
                </GridCell>
            )
            if (this.state.data.resourceStatus === 'Pending') {
                if(this.state.adminComments === false) {
                    actionComponent1 = (
                        <GridCell span = "2">
                            <Button raised style={{ width: '100%'}} onClick = {((e) => handleAdminActivity(e, acceptedStatus))}>Approve</Button>
                        </GridCell>
                    )
                }
                if (this.state.adminComments === false) {
                    if (this.props.isPartner === false) {
                        actionComponent2 = (
                            <GridCell span = "2">
                                <Button dense style={{ width: '100%'}} onClick = {((e) => handleAdminActivity(e, rejectedStatus))}>Reject</Button>
                            </GridCell>
                        )
                    }
                    else {
                        actionComponent2 = (
                            <GridCell span = "2">
                                <Button dense style={{ width: '100%'}} onClick = {((e) => handleAdminComments(e))}>Reject</Button>
                            </GridCell>
                        )

                        onHoldComponent = (
                             <GridCell span = "2">
                                <Button raised style={{ width: '100%'}} onClick = {((e) => handleAdminActivity(e, onHoldStatus))}>Hold</Button>
                            </GridCell>
                        )
                    }
                }
            }
            else if (this.state.data.resourceStatus === 'Rejected') {
                actionComponent1 = (
                    <GridCell span = "2">
                        <Button raised style={{ width: '100%'}} onClick = {((e) => handleAdminActivity(e, acceptedStatus))}>Approve</Button>
                    </GridCell>
                )
                if (this.props.isPartner === true) {
                    onHoldComponent = (
                         <GridCell span = "2">
                            <Button raised style={{ width: '100%'}} onClick = {((e) => handleAdminActivity(e, onHoldStatus))}>Hold</Button>
                        </GridCell>
                    )
                }
            }
            else if (this.state.data.resourceStatus === 'On Hold') {
                actionComponent1 = (
                    <GridCell span = "2">
                        <Button raised style={{ width: '100%'}} onClick = {((e) => handleAdminActivity(e, acceptedStatus))}>Approve</Button>
                    </GridCell>
                )
                
                actionComponent2 = (
                    <GridCell span = "2">
                        <Button dense style={{ width: '100%'}} onClick = {((e) => handleAdminComments(e))}>Reject</Button>
                    </GridCell>
                )
            }
            else {
                if (this.state.adminComments === false) {
                    if (this.props.isPartner === false) {
                        actionComponent2 = (
                            <GridCell span = "2">
                                <Button dense style={{ width: '100%'}} onClick = {((e) => handleAdminActivity(e, rejectedStatus))}>Reject</Button>
                            </GridCell>
                        )
                    }
                    else {
                        actionComponent2 = (
                            <GridCell span = "2">
                                <Button dense style={{ width: '100%'}} onClick = {((e) => handleAdminComments(e))}>Reject</Button>
                            </GridCell>
                        )

                        onHoldComponent = (
                             <GridCell span = "2">
                                <Button raised style={{ width: '100%'}} onClick = {((e) => handleAdminActivity(e, onHoldStatus))}>Hold</Button>
                            </GridCell>
                        )
                    }
                }
                if (this.props.migrationStatus === 'Migrated'){
                    actionComponent3 = (
                        <GridCell span = "2">
                            <Button raised disabled style={{ width: '100%'}}>Migrated</Button>
                        </GridCell>
                    )

                    actionComponent1 = (
                        <GridCell span = "2">
                            <Button raised disabled style={{ width: '100%'}}>Approve</Button>
                        </GridCell>
                    )

                    actionComponent2 = (
                        <GridCell span = "2">
                            <Button raised disabled style={{ width: '100%'}}>Reject</Button>
                        </GridCell>
                    )

                    onHoldComponent = (
                        <GridCell span = "2">
                            <Button raised disabled style={{ width: '100%'}}>Hold</Button>
                        </GridCell>
                    )
                }

                else if (this.props.migrationStatus === 'Not Migrated') {
                    actionComponent3 = (
                        <GridCell span = "2">
                            <Button raised style={{ width: '100%'}} onClick = {((e) => handleMigration(e))}>Migrate</Button>
                        </GridCell>
                    )
                }
            }
        }
        else {
            if (this.state.data.resourceStatus !== "Rejected") {
                actionComponent1 = (
                    <GridCell span = "2">
                        <Button disabled raised style={{ width: '100%'}}>Modify</Button>
                    </GridCell>
                )
            }
            else {
                if ((this.state.data.resourceStatus === "Rejected") && (this.props.adminComments !== undefined)) {
                    actionComponent2 = (
                        <GridCell span = "2">
                            <Button raised style={{ width: '100%'}} onClick = {((e) => handleModify(e))}>Modify</Button>
                        </GridCell>
                    )
                }
                else {
                    if (this.state.data.resourceStatus === "Rejected") {
                        actionComponent1 = (
                            <GridCell span = "2">
                                <Button raised style={{ width: '100%'}} onClick = {((e) => handleModify(e))}>Modify</Button>
                            </GridCell>
                        )
                    }
                }
            }
        } 
    	if (this.props.resourceType === 'link'){
    		docLinkField = (
    			<GridCell span="12">
                    <TextField fullwidth className = 'test_input' label="Link of the Resource" autoComplete="off"  name="resource_link" defaultValue = {this.state.editData.resourceLink} onChange = {this.handleResourceLinkUpdate} style={{ height: '140%' }}/>
                </GridCell>
    		)

    		hiddenComponent = (
    			<div>
                    <TextField autoComplete="off" hidden name="resourcetype"  defaultValue="link"/>
                </div>
    		)
    	}
    	else if (this.props.resourceType === 'document'){
    		docLinkField = (
    			<GridCell span="12">
                    <Typography>Please add the resource document here:  </Typography><input type="file" id="PdfUpload" name="artifact" onChange={this.validateUpload} />
                </GridCell>
    		)

    		hiddenComponent = (
    			<div>
                    <TextField autoComplete="off" hidden name="resourcetype"  defaultValue="document"/>
                </div>
    		)
    	}

    	if (this.state.moreDetails === false){
			detailsButton = (<Button dense style={{ width: '100%'}} onClick = {((e) => handleDetails(e))}>More Details</Button>)
    	}
    	else {
    		detailsButton = (<Button raised style={{ width: '100%'}} onClick = {((e) => handleDetails(e))}>Less Details</Button>)
    	}

    	if (this.state.moreDetails === true){
    		detailsComponent = (
	    		<div>
	    			<Grid className="opportunity-list-item">
                        <GridCell span="3">
                            <Typography align = "left"><b>Author :</b> <i>{this.state.data.resourceAuthor}</i></Typography>
                        </GridCell>
                        <GridCell span="3">
                            <Typography align = "left"><b>Submitted on :</b> <i>{this.props.submissionDate}</i></Typography>
                        </GridCell>
                        {userNameComponent}
                        <GridCell span = "12">
                            <Typography align = "left"><b>Description : </b></Typography>
                            <DiffEditor editorState={this.state.editorData.editorStateRead} readOnly/>
                        </GridCell>
	    				<GridCell span = "12">
	                        <Typography align = "left"><b>Mapped to the following CENTA Aspect(s):</b> <i>{this.props.aspects}</i></Typography>
	                    </GridCell>
	                    <GridCell span = "12">
	                        <Typography align = "left"><b>Mapped to the following CENTA Standard(s):</b> <i>{this.props.standards}</i></Typography>
	                    </GridCell>
                        {gradeComponent}
                        {actionComponent1}
                        {actionComponent2}
                        {actionComponent3}
                        {onHoldComponent}
                        {actionComponent4}
                        {actionComponent5}
                        {actionComponent6}
                        {blankComponent}
                        {commentsComponent}
                        {displayComments}
                        <GridCell span="12">
                            <StatusMessage error_msg = {this.state.errorMsg} />
                        </GridCell>
	    			</Grid>
	    		</div>
	    	)
    	}

            

        if (this.props.isAdmin === false) {
        	if (this.state.modifyForm === false) {
            	displayComponent = (
                    <div>
                		<Grid className="opportunity-list-item">
            				<GridCell span="3">
            					 <Typography> <b>{this.state.data.resourceName}</b> </Typography>
            				</GridCell>
            				<GridCell span="2">
                               <Typography> <a href={this.state.data.resourceLink} target="_blank" style={{cursor: 'pointer'}}> View </a> </Typography>
                            </GridCell>
                            {statusComponent}
                            <GridCell span="3">
                            	{detailsButton}
                            </GridCell>
            			</Grid>
                        {detailsComponent}
                    </div>
            	)
            }
            else if (this.state.modifyForm === true) {
                if (this.props.userType === 'User') {
                	displayComponent = (
                		<div>
                			<form onSubmit= {((e) => this.handleResourceUpdate(e))} style={{ width: '100%' }}>
        	        			<Grid className="opportunity-list-item">
        	        				<GridCell span="8">
        		                        <TextField fullwidth label="Name of the Resource" autoComplete="off"  name="name" defaultValue = {this.state.editData.resourceName} onChange = {this.handleResourceNameUpdate} style={{ height: '140%' }}/>
        		                    </GridCell>
        		                    <GridCell span="4">
        		                        <TextField fullwidth label="Author of the Resource" autoComplete="off"  name="author" defaultValue = {this.state.editData.resourceAuthor} onChange = {this.handleResourceAuthorUpdate} style={{ height: '140%' }}/>
        		                    </GridCell>
        		                    {docLinkField}
        		                    <GridCell span="12">
        	                            <Editor
                                            editorState={this.state.editorData.editorStateRead}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            onEditorStateChange={this.handleEditorDescriptionUpdate}
                                            toolbar={{
                                                options:['inline', 'list' ],
                                                link: { inDropdown: true },
                                                inline:
                                                    {
                                                        options:['bold', 'italic', 'underline']
                                                    },
                                            }}
                                        />
        	                        </GridCell>
        	                        <GridCell span = "6">
        	                            <Reactsel
        	                                name="taxonomylist"
        	                                onChange={this.handleTaxonomyParentUpdate}
        	                                defaultValue={this.state.parentAspect}
        	                                options={this.state.editData.aspectsComboDropDown}
        	                                placeholder="--Select an Aspect--"
        	                                isMulti>
        	                            </Reactsel>
        	                        </GridCell>
        	                        <GridCell span = "6">
        	                            <Reactsel
        	                                name="standardlist"
        	                                onChange={this.handleStandardUpdate}
        	                                value={this.state.parentStandard}
        	                                options={this.state.editData.standardComboDropDown}
        	                                placeholder="--Select a Standard--"
        	                                isMulti>
        	                            </Reactsel>
        	                        </GridCell>
        	                        {uploadButtonComponent}
        	                        <GridCell span = "2">
        		                    	<Button dense style={{ width: '100%'}} onClick = {((e) => CancelModify(e))}>Cancel</Button>
        		                    </GridCell>
        		                    {hiddenComponent}
        	        			</Grid>
                                <StatusMessage error_msg = {this.state.errorMsg} />
                			</form>
                		</div>
                	)
                }
                else {
                    displayComponent = (
                        <div>
                            <form onSubmit= {((e) => this.handleResourceUpdate(e))} style={{ width: '100%' }}>
                                <Grid className="opportunity-list-item">
                                    <GridCell span="8">
                                        <TextField fullwidth label="Name of the Module" autoComplete="off"  name="name" defaultValue = {this.state.editData.resourceName} onChange = {this.handleResourceNameUpdate} style={{ height: '140%' }}/>
                                    </GridCell>
                                    <GridCell span="4">
                                        <TextField fullwidth label="Author of the Module" autoComplete="off"  name="author" defaultValue = {this.state.editData.resourceAuthor} onChange = {this.handleResourceAuthorUpdate} style={{ height: '140%' }}/>
                                    </GridCell>
                                    {docLinkField}
                                    <GridCell span="12">
                                        <Editor
                                            editorState={this.state.editorData.editorStateRead}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            onEditorStateChange={this.handleEditorDescriptionUpdate}
                                            toolbar={{
                                                options:['inline', 'list' ],
                                                link: { inDropdown: true },
                                                inline:
                                                    {
                                                        options:['bold', 'italic', 'underline']
                                                    },
                                            }}
                                        />
                                    </GridCell>
                                    <GridCell span = "6">
                                        <Reactsel
                                            name="taxonomylist"
                                            onChange={this.handleTaxonomyParentUpdate}
                                            defaultValue={this.state.parentAspect}
                                            options={this.state.editData.aspectsComboDropDown}
                                            placeholder="--Select Aspect(s)--"
                                            isMulti>
                                        </Reactsel>
                                    </GridCell>
                                    <GridCell span = "6">
                                        <Reactsel
                                            name="standardlist"
                                            onChange={this.handleStandardUpdate}
                                            value={this.state.parentStandard}
                                            options={this.state.editData.standardComboDropDown}
                                            placeholder="--Select Standard(s)--"
                                            isMulti>
                                        </Reactsel>
                                    </GridCell>
                                    <GridCell span = "12">
                                        <Reactsel
                                            name="gradelist"
                                            onChange={this.handleGradeUpdate}
                                            value={this.state.parentGrade}
                                            options={this.state.editData.gradesDropDown}
                                            placeholder="--Select Grade(s)--"
                                            isMulti>
                                        </Reactsel>
                                    </GridCell>
                                    {uploadButtonComponent}
                                    <GridCell span = "2">
                                        <Button dense style={{ width: '100%'}} onClick = {((e) => CancelModify(e))}>Cancel</Button>
                                    </GridCell>
                                    {hiddenComponent}
                                </Grid>
                                <StatusMessage error_msg = {this.state.errorMsg} />
                            </form>
                        </div>
                    )
                }
            }
        }
        else {
            if (this.state.migration === false) {
                displayComponent = (
                    <div>
                        <Grid className="opportunity-list-item">
                            <GridCell span="3">
                                 <Typography> <b>{this.state.data.resourceName}</b> </Typography>
                            </GridCell>
                            <GridCell span="2">
                               <Typography> <a href={this.state.data.resourceLink} target="_blank" style={{cursor: 'pointer'}}> View </a> </Typography>
                            </GridCell>
                            {adminStatusComponent}
                            <GridCell span="3">
                                {detailsButton}
                            </GridCell>
                        </Grid>
                        {detailsComponent}
                    </div>
                )
            }
            //<TextField textarea fullwidth label="Description" rows="2" name="resourcedesc" defaultValue = {this.state.editData.resourceDesc} onChange={this.handleResourceDescUpdate} />
            else if (this.state.migration === true) {
                displayComponent = (
                    <div>
                        <form onSubmit= {((e) => this.handleAdminResourceSave(e))} style={{ width: '100%' }}>
                            <Grid className="opportunity-list-item">
                                <GridCell span="12">
                                    <Typography align = "left"> Please note that once the resource has been migrated, it <b> CANNOT </b> be reversed. Please make sure that the correct resource is migrated. </Typography>
                                </GridCell>
                                <GridCell span="8">
                                    <TextField fullwidth label="Name of the Resource" autoComplete="off"  name="resourcename" defaultValue = {this.state.editData.resourceName} onChange = {this.handleResourceNameUpdate} style={{ height: '140%' }}/>
                                </GridCell>
                                <GridCell span="4">
                                    <TextField fullwidth label="Author of the Resource" autoComplete="off"  name="resourceauthor" defaultValue = {this.state.editData.resourceAuthor} onChange = {this.handleResourceAuthorUpdate} style={{ height: '140%' }}/>
                                </GridCell>
                                <GridCell span="12">
                                    <TextField fullwidth label="Link of the Resource" autoComplete="off"  name="resourcelink" defaultValue = {this.state.editData.resourceLink} onChange = {this.handleResourceLinkUpdate} style={{ height: '140%' }}/>
                                </GridCell>
                                <GridCell span="12">
                                    <GridCell span="12">
                                        <Editor
                                            editorState={this.state.editorData.editorStateRead}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            onEditorStateChange={this.handleEditorDescriptionUpdate}
                                            toolbar={{
                                                options:['inline', 'list' ],
                                                link: { inDropdown: true },
                                                inline:
                                                    {
                                                        options:['bold', 'italic', 'underline']
                                                    },
                                            }}
                                        />
                                    </GridCell>
                                </GridCell>
                                <GridCell span = "4">
                                    <Select
                                        name="languagesection"
                                        onChange={this.handleLanguageChange}
                                        defaultValue={this.state.editData.languageId}
                                        className="select-component"
                                        placeholder="--Select the Language--">
                                        {this.state.editData.languageDropDown.map(list => (
                                            <option key={list.id} value={list.id} data-name={list.name}>
                                                {list.name}
                                            </option>
                                        ))}
                                    </Select>
                                </GridCell>
                                <GridCell span="4">
                                    <Select
                                        name="complexity_id"
                                        onChange={this.handleComplexityChange}
                                        defaultValue={this.state.editData.complexityId}
                                        className="select-component"
                                        placeholder="--Select Complexity--">
                                        {this.state.editData.complexityDropDown.map(complexity => (
                                            <option key={complexity.id} value={complexity.id} data-name={complexity.name}>
                                                {complexity.name}
                                            </option>
                                        ))}
                                    </Select>
                                </GridCell>
                                <GridCell span="4">
                                    <Select
                                        name="resource_class"
                                        onChange={this.handleResourceClassChange} 
                                        value={this.state.editData.resourceClass}
                                        defaultValue={this.state.editData.resourceClass}
                                        placeholder = '--Internal Vs External--'
                                        className="select-component" >

                                        <option value="internal">Internal</option>
                                        <option value="external">External</option>
                                    </Select>
                                </GridCell>
                                <GridCell span="4">
                                    <Select
                                        name="centa_rating"
                                        onChange={this.handleCentaRatingsChange} 
                                        value={this.state.editData.centaRating}
                                        defaultValue={this.state.editData.centaRating}
                                        placeholder = '--CENTA Rating--'
                                        className="select-component" >

                                        <option value="1">1 Star</option>
                                        <option value="2">2 Stars</option>
                                        <option value="3">3 Stars</option>
                                        <option value="4">4 Stars</option>
                                        <option value="5">5 Stars</option>
                                    </Select>
                                </GridCell>
                                <GridCell span="4">
                                </GridCell>
                                <GridCell span="4">
                                    <Select
                                        name="level_id"
                                        onChange={this.handleLevelsChange}
                                        defaultValue={this.state.editData.levelId}
                                        className="select-component"
                                        placeholder="--Select Level--">
                                        {this.state.editData.levelDropDown.map(level => (
                                            <option key={level.value} value={level.value} data-name={level.label}>
                                                {level.label}
                                            </option>
                                        ))}
                                    </Select>
                                </GridCell>
                                <GridCell span="6">
                                    <Reactsel
                                        name="trackslist"
                                        onChange={this.handleResAssociatedTracks}
                                        defaultValue={this.state.addedTracks}
                                        options={this.state.editData.trackDropDown}
                                        placeholder="--Select Track--"
                                        isMulti>
                                    </Reactsel>
                                </GridCell>
                                <GridCell span = "6">
                                    <Reactsel
                                        name="pre_read_list"
                                        onChange={this.handleBackwardLink}
                                        value={this.state.addedResource}
                                        options={this.state.editData.resourceDropDown}
                                        placeholder="--Select Pre-Read Resource--"
                                        isMulti>
                                    </Reactsel>
                                </GridCell>
                                <GridCell span="12">
                                    <Reactsel
                                        name="buzzwordslist"
                                        onChange={this.handleBuzzwordsChange}
                                        defaultValue={this.state.addedBuzzwords}
                                        value={this.state.addedBuzzwords}
                                        options={this.state.editData.buzzwordDropDown}
                                        placeholder="--Select associated Keywords--"
                                        isMulti>
                                    </Reactsel>
                                </GridCell>
                                <GridCell span = "6">
                                    <Reactsel
                                        name="taxonomylist"
                                        onChange={this.handleTaxonomyParentUpdate}
                                        defaultValue={this.state.parentAspect}
                                        options={this.state.editData.aspectsComboDropDown}
                                        placeholder="--Select an Aspect--"
                                        isMulti>
                                    </Reactsel>
                                </GridCell>
                                <GridCell span = "6">
                                    <Reactsel
                                        name="standardlist"
                                        onChange={this.handleStandardUpdate}
                                        value={this.state.parentStandard}
                                        options={this.state.editData.standardComboDropDown}
                                        placeholder="--Select a Standard--"
                                        isMulti>
                                    </Reactsel>
                                </GridCell>
                                {saveComponent}
                                <GridCell span = "2">
                                    <Button dense style={{ width: '100%'}} onClick = {((e) => cancelMigrate(e))}>Cancel</Button>
                                </GridCell>
                                <GridCell span = "2">
                                    <TextField autoComplete="off" hidden name="user_resource_id"  value={this.state.data.resourceId}/>
                                </GridCell>
                                <GridCell span = "2">
                                    <TextField autoComplete="off" hidden name="resourcetype"  value="link"/>
                                </GridCell>
                                <GridCell span="12">
                                    <StatusMessage error_msg = {this.state.errorMsg} />
                                </GridCell>
                            </Grid>
                        </form>
                    </div>
                )
            }
        }
    	return(
    		<div>
    			{displayComponent}
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserUploadedResComponent);


// WEBPACK FOOTER //
// ./src/views/learning_resource_user/UserUploadedResComponent.jsx